import { SET_OUTLETCATEGORIES } from "../actions";

const outletcategories = (state = [], action) => {
  switch (action.type) {
    case SET_OUTLETCATEGORIES:
      return [...action.value];
    default:
      return state;
  }
};

export default outletcategories;
